export default {
	loadedResources: [],
	airportsOpts: [],
	ratePlansOpts: [],
	zonedAreasOpts: [],
	destinationsOpts: [],
	reasonStateOpts: [],
	reasonStateActiveOpts: [],
	reasonStatesSupplierRemmitanceOpts:[],
	suppliersOpts: [],
	serviceTypesOpts: [],
	salesChannelsOpts: [],
	countriesOpts: [],
	timeZonesOpts: [],
	pointOfSalesOpts:[],
	usersOpts:[],
	profilesOpts: [],
	masterZonedAreasOpts: [],
	serviceTypesCategoriesOpts:[],
	tagsOpts:[],
	currencyOpts: [
		{ value: "mxn", text: "MXN" },
		{ value: "usd", text: "USD" },
		{ value: "eur", text: "EUR" },
		{ value: "gbp", text: "GBP" },
		{ value: "cop", text: "COP" },
		{ value: "cad", text: "CAD"}
	],
	langOpts: [
		{ value: "es", text: "Español" },
		{ value: "en", text: "Ingles" }
	],
	webCheckingStatus: [
		{ value: "pending", text: "Pendiente", class: "secondary" },
		{ value: "started", text: "Iniciado", class: "warning" },
		{ value: "acepted", text: "Aceptado", class: "success" },
	],
	transportServiceContactStatusOpts: [
		{ value: "noContacted", text: "No confirmado" },
		{ value: "byCall", text: "Por llamada" },
		{ value: "byMail", text: "Por email" },
		{ value: "byApp", text: "Por App" },
		{ value: "byWhatsapp", text: "Por Whatsapp" },
		{ value: "byMsg", text: "Por mensaje texto" }
	],
	transportServiceStatusOpts: [
		{ value: "pending", text: "Pendiente", class: "secondary" },
		{ value: "active", text: "Activo", class: "default" },
		{ value: "noShow", text: "No show", class: "info" },
		{ value: "noProvided", text: "No atendido", class: "warning" },
		{ value: "canceled", text: "Cancelado", class: "danger" },
		{ value: "done", text: "Realizado", class: "success" },
		{ value: "partialCancellation", text: "Pre Cancelado", class: "partialCancellation" }
	],
	transportServiceTrackingStatusOpts: [
		{ value: "pending", text: "Por iniciar" },
		{ value: "onWayToPickup", text: "Rumbo a pickup" },
		{ value: "atPickup", text: "En lugar de pickup" },
		{ value: "onWayToDropoff", text: "Rumbo a dropoff" },
		{ value: "finished", text: "Completado" },
		{ value: "noShow", text: "Completado (No show)" }
	],
	transportServiceStatusClasses: {
		pending: "secondary",
		active: "default",
		canceled: "danger",
		noShow: "info",
		noProvided: "warning",
		done: "success",
		partialCancellation: "partialCancellation"
	},
	reservationStatusOpts: [
		{ value: "active", text: "Activo" },
		{ value: "canceled", text: "Cancelado" }
	],
	tripOpts: [
		{ value: "A2H", text: "A2H" },
		{ value: "H2A", text: "H2A" },
		{ value: "P2P", text: "P2P" }
	],
	supplierConfirmationOpts: [
		{ value: "pending", text: "Pendiente de confirmación" },
		{ value: "confirmed", text: "Confirmado" },
		{ value: "rejected", text: "Rechazado" }
	],
	transportServicePaymentStatusOpts: [
		{ value: "pending", text: "No generado", class: "secondary" },
		{ value: "waiting", text: "En espera", class: "warning" },
		{ value: "paid", text: "Pagado", class: "success" },
	],
	apiLogTags: [
		{ value: "success", text: "Success" },
		{ value: "badRequest", text: "Bad Request" },
		{ value: "error", text: "Server Error" }
	],
	googleKeyMap: "AIzaSyAI9hrAoEYgpSRYA7MMOc2oKptDCZ-5uMs",
	async search(component, resource, term) {
		let res = await component.$root.api.post(resource, { term });
		return res.data.map(item => ({ value: item.id, text: item.code }));
	},
	resetResource(resourceName) {
		let index = this.loadedResources.indexOf(resourceName);
		if (index) this.loadedResources.splice(index, 1);
	},

	async fetchApi({
		vm,
		route,
		limit,
		itemValue,
		itemText,
		returnAll = false
	}) {
		try {
			const response = await vm.$root.api.get(`${route}`, {
				params: { limit }
			});
			if (returnAll) return response.data;
			const rows = response.data.rows || response.data;
			return rows.map(item => ({
				...item,
				value: item[itemValue],
				text: item[itemText],
			}));
		} catch (error) {
			console.log(error);
			return [];
		}
	},

	async loadResourcesOpts({ vm, resourceNames, forceRefresh = false }) {
		for (const resourceName of resourceNames) {
			if (
				this.loadedResources.find(x => x === resourceName) &&
				!forceRefresh
			)
				continue;
			this.loadedResources.push(resourceName);
			if (resourceName === "suppliersOpts") {
				this.suppliersOpts = [];
				this.suppliersOpts = await this.fetchApi({
					vm,
					route: "/suppliers",
					limit: 2000,
					itemValue: "id",
					itemText: "code"
				});
			}
			if (resourceName === "reasonStates") {
				this.reasonStateOpts = [];
				this.reasonStateOpts = await this.fetchApi({
					vm,
					route: "/reasonStates",
					limit: 2000,
					itemValue: "id",
					itemText: "label",
					returnAll: true
				});
			}
			if (resourceName === "reasonStatesActive") {
				this.reasonStateActiveOpts = [];
				this.reasonStateActiveOpts = await this.fetchApi({
					vm,
					route: "/reasonStates?active=true",
					limit: 2000,
					itemValue: "id",
					itemText: "label",
					returnAll: true
				});
			}
			if (resourceName === "reasonStatesSupplierRemmitanceOpts") {
				this.reasonStatesSupplierRemmitanceOpts = [];
				this.reasonStatesSupplierRemmitanceOpts = await this.fetchApi({
					vm,
					route: "/reason-states/module/supplier-remittance?active=true",
					limit: 2000,
					itemValue: "id",
					itemText: "label",
					returnAll: true
				});
			}
			if (resourceName === "serviceTypesOpts") {
				this.serviceTypesOpts = [];
				this.serviceTypesOpts = await this.fetchApi({
					vm,
					route: "/service-types",
					limit: 2000,
					itemValue: "id",
					itemText: "code"
				});
			}
			if (resourceName === "salesChannelsOpts") {
				this.salesChannelsOpts = [];
				this.salesChannelsOpts = await this.fetchApi({
					vm,
					route: "/sales-channels",
					limit: 2000,
					itemValue: "id",
					itemText: "code"
				});
			}
			if (resourceName === "destinationsOpts") {
				this.destinationsOpts = [];
				this.destinationsOpts = await this.fetchApi({
					vm,
					route: "/destinations",
					limit: 5000,
					itemValue: "id",
					itemText: "name"
				});
			}
			if (resourceName === "countriesOpts") {
				this.countriesOpts = [];
				this.countriesOpts = await this.fetchApi({
					vm,
					route: "/countries",
					limit: 2000,
					itemValue: "id",
					itemText: "name"
				});
			}

			if (resourceName === "airportsOpts") {
				this.airportsOpts = [];
				this.airportsOpts = await this.fetchApi({
					vm,
					route: "/airports",
					limit: 2000,
					itemValue: "id",
					itemText: "name"
				});
			}
			if (resourceName === "zonedAreasOpts") {
				this.zonedAreasOpts = [];
				this.zonedAreasOpts = await this.fetchApi({
					vm,
					route: "/zoned-areas",
					limit: 2000,
					itemValue: "id",
					itemText: "name"
				});
			}
			if (resourceName === "ratePlansOpts") {
				this.ratePlansOpts = [];
				this.ratePlansOpts = await this.fetchApi({
					vm,
					route: "/rate-plans",
					limit: 2000,
					itemValue: "id",
					itemText: "name"
				});
			}
			if (resourceName === "timeZonesOpts") {
				this.timeZonesOpts = [];
				this.timeZonesOpts = await this.fetchApi({
					vm,
					route: "/time-zones",
					limit: 2000,
					itemValue: "id",
					itemText: "name"
				});
			}
			if (resourceName === "pointOfSalesOpts") {
				this.pointOfSalesOpts = [];
				this.pointOfSalesOpts = await this.fetchApi({
					vm,
					route: "/point-of-sales",
					limit: 2000,
					itemValue: "id",
					itemText: "codename"
				});
			}
			if (resourceName === "usersOpts") {
				this.usersOpts = [];
				this.usersOpts = await this.fetchApi({
					vm,
					route: "/users",
					limit: 2000,
					itemValue: "id",
					itemText: "firstName"
				});
			}

			if (resourceName === "profilesOpts") {
				this.profilesOpts = [];
				this.profilesOpts = await this.fetchApi({
					vm,
					route: "/profiles",
					limit: 2000,
					itemValue: "id",
					itemText: "name"
				});
			}

			if (resourceName === "masterZonedAreasOpts") {
				this.masterZonedAreasOpts = [];
				this.masterZonedAreasOpts = await this.fetchApi({
					vm,
					route: "zoned-areas/master?withZones=true",
					limit: 2000,
					itemValue: "id",
					itemText: "name",
					returnAll: true
				})
			}
			if (resourceName === "serviceTypesCategories") {
				this.serviceTypesCategoriesOpts = [];
				this.serviceTypesCategoriesOpts = await this.fetchApi({
					vm,
					route: "/service-types-categories",
					limit: 2000,
					itemValue: "id",
					itemText: "name"
				});
			}
			if (resourceName === "tagsOpts") {
				this.tagsOpts = [];
				this.tagsOpts = await this.fetchApi({
					vm,
					route: "tags",
					limit: 2000,
					itemValue: "id",
					itemText: "text"
				});
			}
		}
	},

};
